"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _find = _interopRequireDefault(require("lodash/find"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Notification = _interopRequireDefault(require("./Notification"));

var _NotificationPropTypes = _interopRequireDefault(require("./NotificationPropTypes"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var NotificationContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(NotificationContainer, _Component);

  function NotificationContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, NotificationContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(NotificationContainer).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      currentNotification: _this.props.notification
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onRemove", function () {
      _this._notificationQueue.shift(); // clear the state first so that it causes a re-render and the queue can be re-checked


      _this.setState({
        currentNotification: null
      });
    });
    var notification = props.notification;
    _this._notificationQueue = [];

    if (notification) {
      _this._notificationQueue.push(notification);
    }

    return _this;
  }

  (0, _createClass2.default)(NotificationContainer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props,
          notification = _this$props.notification,
          onQueueEmpty = _this$props.onQueueEmpty;

      this._checkQueue();

      if (prevState.currentNotification && !this.state.currentNotification && !this._notificationQueue.length && onQueueEmpty) {
        onQueueEmpty();
      } else if (notification && !(0, _find.default)(this._notificationQueue, {
        id: notification.id
      })) {
        this._notificationQueue.push(notification);

        this._checkQueue();
      }
    }
  }, {
    key: "_checkQueue",
    value: function _checkQueue() {
      if (this.state.currentNotification || !this._notificationQueue.length) {
        return;
      }

      this.setState({
        currentNotification: this._notificationQueue[0]
      });
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      var currentNotification = this.state.currentNotification;
      var classes = (0, _classnames.default)('NotificationContainer', className);
      return _react.default.createElement("div", {
        className: classes
      }, currentNotification && _react.default.createElement(_Notification.default, (0, _extends2.default)({
        onRemove: this._onRemove
      }, currentNotification)));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return NotificationContainer;
}(_react.Component);

exports.default = NotificationContainer;
(0, _defineProperty2.default)(NotificationContainer, "propTypes", {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** A notification to queue up for display. */
  notification: _propTypes.default.shape((0, _objectSpread2.default)({}, _NotificationPropTypes.default)),

  /** A function to execute when the notification queue is empty. Use this to clear your local state of any associated notification data. */
  onQueueEmpty: _propTypes.default.func
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(NotificationContainer, "NotificationContainer", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Notification/NotificationContainer.jsx");
  leaveModule(module);
})();

;